// Central SEO constants. The production origin is hardcoded (not an env var)
// because it isn't build-configurable today — unlike VITE_MAP_API_KEY/
// VITE_MAP_ID, wiring it through docker-compose.yml/the Dockerfile's
// --build-arg would need to happen in three separate deploy configs for a
// value that never actually changes — and a canonical URL should always
// point at the one real production origin regardless of which host (a
// preview build, localhost, a future staging domain) served the page.
export const SITE_URL = "https://tecoapp.io";
export const SITE_NAME = "Teco";
export const DEFAULT_LOCALE = "en_KE";
export const DEFAULT_OG_IMAGE = `${SITE_URL}/imgs/logo/complete-250.png`;
export const TWITTER_CARD = "summary_large_image";

/**
 * Build the canonical URL for a path: strips query strings/hashes, drops a
 * trailing slash (except for "/" itself), and joins it to SITE_URL.
 * @param {string} path - e.g. "/stores/abc123" or "/stores/abc123?tab=menu"
 * @returns {string}
 */
export function buildCanonicalUrl(path) {
  const clean = String(path || "/").split("?")[0].split("#")[0];
  const normalized =
    clean.length > 1 && clean.endsWith("/") ? clean.slice(0, -1) : clean;
  return `${SITE_URL}${normalized.startsWith("/") ? normalized : `/${normalized}`}`;
}
